import { jsx as _jsx } from "react/jsx-runtime";
export function TableHeader({ children }) {
    return (_jsx("thead", { className: "text-caption sticky top-0 z-10 bg-surface-muted", children: children }));
}
